<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" style="position: absolute; z-index: -1000">
  <defs>
    <pattern id="diagonalHatch" [attr.width]="size" [attr.height]="size" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
      <line class="line-stroke" x1="0" y1="0" x2="0" [attr.y2]="size" [style.stroke-width]="size*2" />
      <line class="line-stroke-over" x1="0" y1="0" x2="0" [attr.y2]="size" [style.stroke-width]="size" />
    </pattern>

    <pattern id="diagonalHatchHover" [attr.width]="size" [attr.height]="size" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
      <line class="line-stroke hover" x1="0" y1="0" x2="0" [attr.y2]="size" [style.stroke-width]="size*2" />
      <line class="line-stroke-over hover" x1="0" y1="0" x2="0" [attr.y2]="size" [style.stroke-width]="size" />
    </pattern>
  </defs>
</svg>
